import { LandOwnershipEntityFilters } from "src/utils/api/dashboard";
import { useRecordEntityOptions } from "./useRecordEntityOptions";

export const useLandOwnershipEntityOptions = (
  filters: LandOwnershipEntityFilters,
  enabled = true
) => {
  return useRecordEntityOptions("landOwnership", filters, enabled);
};
